module.exports = __webpack_public_path__ + "media/images/bnr_special_fukushima12-e48cbb85b9f48c03d28f79d79050ec1c.jpg";